import { useEffect } from 'react'
import { useAction, useAppSelector } from '@shared/lib/redux'

import { THEME_NAME, defaultTheme } from '../../lib'
import { themeStore } from './theme.slice'

export const useTheme = () => {
  const toggleTheme = useAction((value: boolean) =>
    themeStore.actions.toggleDarkTheme(value)
  )
  const isDarkTheme = useAppSelector(themeStore.selectors.selectIsDarkTheme)
  return { isDarkTheme, toggleTheme }
}

export const useTrackTheme = () => {
  useEffect(() => {
    const isDarkThemeChecked = JSON.stringify(defaultTheme)
    document.documentElement.setAttribute(THEME_NAME, isDarkThemeChecked)
    localStorage.setItem(THEME_NAME, isDarkThemeChecked)
  }, [])
}
